module.exports = __webpack_public_path__ + "static/img/logoName.fe2eb0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logoName.png
// module id = HsQk
// module chunks = 1